import { useAuth } from "@/provider/UserProvider";
import { buyAvatarDecor } from "@/services/decoration";
import { useState } from "react";
import { toast } from "react-toastify";

const useBuy = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<{ success: boolean, message: string, id: number } | null>(null);
  const { auth, isLoginClient, setAuth } = useAuth();

  const handleBuy = async (id: number, price: number, callback: Function) => {
    setResult(null);
    if (!isLoginClient) {
      setResult({
        success: false,
        message: 'Please login to continue',
        id
      });
      return;
    };
    if (auth.user.credit < price) {
      setResult({
        success: false,
        message: 'Not enough credits',
        id
      });
      return;
    }; 

    try {
      setLoading(true);
      await buyAvatarDecor(id);
      setResult({
        success: true,
        message: 'Bought successfully',
        id
      });
      callback();
      setAuth(prev => ({ 
        ...prev, 
        user : { 
          ...prev.user, 
          credit: prev.user.credit - price 
        }
      }));
      toast.success('Bought decoration successfully!')
    } catch (error) {
      setResult({
        success: false,
        message: 'Failed, please try again!',
        id
      });
    } finally {
      setLoading(false)
    }
  }

  return {
    handleBuy,
    loading,
    result,
    setResult
  }

}

export default useBuy;